import {
  FormControlLabel as MuiFormControlLabel,
  type FormControlLabelProps as MuiFormControlLabelProps
} from '@mui/material';

export type FormControlLabelProps = MuiFormControlLabelProps;

export const FormControlLabel = (props: Readonly<FormControlLabelProps>) => (
  <MuiFormControlLabel {...props} />
);
